var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 21C17.0331 21 21.0625 16.9706 21.0625 12C21.0625 7.02944 17.0331 3 12.0625 3C7.09194 3 3.0625 7.02944 3.0625 12C3.0625 16.9706 7.09194 21 12.0625 21Z",
    stroke: "#2F80ED",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 7.5V12.75",
    stroke: "#2F80ED",
    strokeWidth: 1.47711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 17.25C12.6838 17.25 13.1875 16.7463 13.1875 16.125C13.1875 15.5037 12.6838 15 12.0625 15C11.4412 15 10.9375 15.5037 10.9375 16.125C10.9375 16.7463 11.4412 17.25 12.0625 17.25Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.d0f9ce3d235953820b8597a3aec133a0.svg";
export { ForwardRef as ReactComponent };